// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"83cfc662","213":"4e748241","239":"9180e550","390":"06606e2c","453":"258b012d","455":"5579f3f0","495":"67744626","592":"6bc755d9","696":"4533d9fa","804":"d7166782","838":"2ccfd16e","922":"272c83c4"}[chunkId] + ".chunk.js";
};